import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import { Cadastro, Tipos } from "../../data/interfaces";
import * as images from "../../images/images";
import * as api from "../../services/firebase";
import Busca from "./components/busca";
import Detalhe from "./components/detalhe";
import {
  Picture,
  Title,
  SubTitle,
  Container,
  Person,
  Information,
  Endereco,
  Telefone,
  Imagem,
  Back,
} from "./styles";

function Loja() {
  const primeiro = {} as Cadastro;
  const [lojas, setLojas] = useState<Cadastro[]>([]);
  const [lojasTmp, setLojasTmp] = useState<Cadastro[]>([]);
  const [cadastroSelecionado, setCadastroSelecionado] = useState<Cadastro>(
    primeiro
  );
  const { id, share } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (share === "1") {
      const detalheDiv = document.querySelector("#detalhe");
      detalheDiv?.setAttribute("style", "display: block");
      const listaDiv = document.querySelector("#lista");
      listaDiv?.setAttribute("style", "display: none");
    } else {
      const detalheDiv = document.querySelector("#detalhe");
      detalheDiv?.setAttribute("style", "display: none");
      const listaDiv = document.querySelector("#lista");
      listaDiv?.setAttribute("style", "display: block");
    }
  }, [id, share]);

  useEffect(() => {
    api.getListaCadastro(Tipos.LOJAS, (cadastros: Cadastro[]) => {
      setLojas(cadastros);
      setLojasTmp(cadastros);
      if (share) {
        const itemShare: Cadastro = cadastros
          .filter((item) => item.key === id)
          .shift() as Cadastro;
        if (itemShare) {
          setCadastroSelecionado(itemShare);
        }
      }
    });
  }, [id, share]);

  function handleChange(newValue: Cadastro[]) {
    setLojas(newValue);
  }

  function handleSelect(newValue: Cadastro) {
    setCadastroSelecionado(newValue);
    history.push("/loja/0/1");
  }

  function handleBack() {
    history.push("/lojas");
  }

  return (
    <>
      <div id="lista" style={{ display: "none" }}>
        <Imagem src={images.imgAlimentos5} alt="foto" />
        <Busca
          cadastros={lojas}
          cadastrosTmp={lojasTmp}
          onChange={handleChange}
        />
        <Container>
          {lojas.map((loja) => (
            <Person
              key={loja.key}
              onClick={() => {
                handleSelect(loja);
              }}
            >
              <Picture src={loja.urlImage} alt="Foto" />
              <Information>
                <Title fontSize={16}>{loja.nome.toLowerCase()}</Title>
                <SubTitle>{loja.especialidade}</SubTitle>
                <Telefone>{loja.telefone}</Telefone>
                <Endereco>{loja.endereco}</Endereco>
              </Information>
            </Person>
          ))}
        </Container>
      </div>
      <div id="detalhe" style={{ display: "block" }}>
        <Back
          onClick={() => {
            handleBack();
          }}
        />
        <Detalhe cadastro={cadastroSelecionado} />
      </div>
    </>
  );
}

export default Loja;
